import { TableCell, TableRow } from '@mui/material'
import { BetDetailsType } from '@/state/common'

export interface Props {
  row: BetDetailsType
}

export const BetDetailsTableRowComponent = ({ row }: Props) => {
  return (
    <TableRow hover>
      <TableCell>{row.leagueDescription}</TableCell>
      <TableCell>{row.productDescription}</TableCell>
      <TableCell>{row.sportId}</TableCell>
      <TableCell>{row.sportDescription}</TableCell>
      <TableCell>{row.gameDescription}</TableCell>
      <TableCell>{row.pickLine.join(' - ')}</TableCell>
    </TableRow>
  )
}
